import React from "react";
import "./LoadingState.css";

export function LoadingState({ message = "Loading..." }) {
  return (
    <div className="loading-state-wrapper">
      <div className="loading-spinner"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
}

export function ErrorState({ message = "An error occurred. Please try again.", onRetry }) {
  return (
    <div className="error-state-wrapper">
      <div className="error-icon">⚠️</div>
      <p className="error-message">{message}</p>
      {onRetry && (
        <button className="retry-button" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({ message = "No data available" }) {
  return (
    <div className="empty-state-wrapper">
      <div className="empty-icon">📭</div>
      <p className="empty-message">{message}</p>
    </div>
  );
}
